const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "back",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7D7A9"
    },
    cx: 151.2,
    cy: 117.5,
    r: 78
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9A5A79"
    },
    d: "M276.8,263.3V300H25.6v-36.7c0-40.2,56.2-86.4,125.6-86.4S276.8,223,276.8,263.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#49250A"
    },
    d: "M229.2,117.5c0,43.1-15.7,89.3-15.7,89.3L201,195.5l-12.5,11.3l-12.5-11l-12.5,11l-12.5-11l-12.5,11 l-12.5-11l-12.5,11l-12.5-11l-12.5,11c0,0-15-68.6-15-89.3c0-43.1,34.9-78,78-78S229.2,74.4,229.2,117.5L229.2,117.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "boomerang-blue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boomerang-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B59767"
    },
    d: "M89.7,185.1c-9,13.5,91.2,87.5,75,124.7c-11.5,26.5-43.9,52.8-44.2,70.1 c-0.2,13.5,58.1-12.1,75.6-61.8C214.9,264.8,100.9,168.2,89.7,185.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2B985"
    },
    d: "M89.7,185.1c-4.8,7.6,24.2,34.7,48,63.7c18.7,22.8,34.1,46.6,27,62.9c-11.5,26.3-44.2,56.2-44,69.5 c0.2,11.3,58.7-11.6,75.4-61.2c7.7-22.9-12.8-56-37.8-83.8C129.1,203.9,93.7,178.7,89.7,185.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "boomerang-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0C62A3"
    },
    d: "M148.3,225.7l2.8-3.5c9.4,9.3,17.9,19.4,25.6,30.2l-2.4,3.3v0.1c-4.9-6.6-10.4-13.2-16-19.5 C155,232.6,151.7,229.1,148.3,225.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3884D6"
    },
    d: "M130.1,239.8c0,0,0.2-0.1,0.7-0.2c2.5-1,4.9-2.3,7-3.9c4.4-3.2,10.6-9.9,10.6-9.9 c3.4,3.4,6.7,6.9,9.9,10.6c5.7,6.3,11.1,12.9,16,19.5c-2.4,3.4-5.3,6.3-8.7,8.8c-3.2,2.6-6.8,4.6-10.6,6.1 c-0.3,0.1-0.6,0.2-0.8,0.3c-5.1-7.7-10.5-15.1-16.4-22.1C135.2,245.8,132.6,242.7,130.1,239.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C4A37"
    },
    d: "M127.8,237.1l0.6-0.2c2.4-1,4.7-2.3,6.9-3.9c4.2-3,10.4-9.9,10.4-9.9l2.7-3.6l1.5,1.5l1.2,1.2l0,0 l-2.8,3.5c0,0-6.2,6.7-10.6,9.9c-2.2,1.6-4.5,2.9-7,3.9c-0.2,0.1-0.4,0.1-0.7,0.2l-0.4-0.5L127.8,237.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C4A37"
    },
    d: "M154.1,270.9c0.3-0.1,0.6-0.2,0.8-0.3c3.8-1.6,7.4-3.6,10.7-6.1c3.4-2.4,6.3-5.4,8.7-8.8v-0.1 l2.4-3.3l0.1,0.1l1.9,2.7l-2.3,3.4l0,0c-2.4,3.2-5.3,6.1-8.6,8.4c-3.4,2.6-7.2,4.7-11.1,6.4c-0.5,0.2-0.7,0.3-0.7,0.3l-0.9-1.4 L154.1,270.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "boomerang-red"
  }, /*#__PURE__*/React.createElement("g", {
    id: "boomerang-5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B59767"
    },
    d: "M201.4,168.2c-16.2,0.7-16.7,125.2-56.3,134.2c-28.2,6.4-68.5-4.3-82.7,5.8 c-11,7.8,44.1,39.7,94.6,24.5C211.1,316.2,221.6,167.3,201.4,168.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2B985"
    },
    d: "M201.4,168.2c-9,0.6-13.7,40.1-23,76.4c-7.3,28.5-17.5,55.1-34.8,59c-28,6.3-71.4-2.5-82.1,5.6 c-9,6.8,44.1,40.5,93.9,24.7c23-7.3,37.6-43.4,45.3-80C209.5,211.1,209,167.6,201.4,168.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "boomerang-6"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A11D28"
    },
    d: "M203.3,239.4l4.5,0.2c-2,13.1-5.1,26-9.2,38.5l-4.1,0.1h-0.1c2.5-7.9,4.6-16.2,6.3-24.5 C201.6,248.9,202.5,244.2,203.3,239.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C93131"
    },
    d: "M181.1,233c0,0,0.2,0.1,0.5,0.4c2.3,1.5,4.7,2.6,7.3,3.4c5.2,1.7,14.3,2.7,14.3,2.7 c-0.8,4.8-1.6,9.5-2.7,14.3c-1.7,8.3-3.8,16.6-6.3,24.5c-4.1,0.1-8.3-0.5-12.2-1.8c-4-1.1-7.8-2.8-11.2-5 c-0.2-0.2-0.5-0.3-0.7-0.5c3.2-8.6,5.9-17.4,8.2-26.3C179.3,240.7,180.2,236.9,181.1,233z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C4A37"
    },
    d: "M181.9,229.6l0.5,0.4c2.3,1.3,4.7,2.4,7.2,3.3c4.9,1.7,14.1,2.5,14.1,2.5l4.5,0.1L208,238l-0.2,1.6 l0,0l-4.5-0.2c0,0-9.1-1-14.3-2.7c-2.6-0.8-5-1.9-7.3-3.4c-0.2-0.1-0.4-0.3-0.5-0.4l0.1-0.6C181.5,231.5,181.7,230.6,181.9,229.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C4A37"
    },
    d: "M170.2,270.9c0.2,0.2,0.5,0.4,0.7,0.5c3.5,2.2,7.3,3.8,11.2,5c3.9,1.3,8.1,1.9,12.2,1.8h0.1l4.1-0.1 l-0.1,0.1l-1.1,3.1l-4.1,0.1l0,0c-4,0-8-0.7-11.8-1.9c-4.1-1.3-8-3-11.7-5.2c-0.5-0.3-0.7-0.4-0.7-0.4l0.6-1.6L170.2,270.9z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F3205"
    },
    d: "M63.6,202.4c0,0,53.3,82.2,110.7,104.4s102.5,21.8,102.5,21.8v15c0,0-68.4-1.2-106.6-19.1 c-74.4-35-121.1-110.3-121.1-110.3L63.6,202.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7A4909"
    },
    d: "M62.2,203.6c0,0,53.3,82.2,110.7,104.4s102.5,21.8,102.5,21.8v15c0,0-68.4-1.2-106.6-19.1 c-74.3-35-121-110.3-121-110.3L62.2,203.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC7D7D"
    },
    d: "M28.2,84.1c0,17.7,77.7,30.4,123.6,30.4s122.7-15.9,122.7-30.4s-73.8-17.8-122.7-17.7 C103.2,66.5,28.2,69.1,28.2,84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59191"
    },
    d: "M78.1,76.4c0,11.5,43.8,18.9,73.6,18.9s70-8.5,70-18s-18.6-60.5-71.8-60.5 C89,16.8,78.1,66.6,78.1,76.4z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.60c922c8da3e46f45b32f00b64098e29.svg";
export { ForwardRef as ReactComponent };